"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CountdownTimer = exports.CountdownSection = exports.CountdownContainer = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _coreSpan = require("@legacy-vfuk/core-span");

var _coreMixins = require("@legacy-vfuk/core-mixins");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var CountdownContainer = _styledComponents["default"].div.withConfig({
  displayName: "DateCountdownstyle__CountdownContainer",
  componentId: "sc-1un6wh7-0"
})(function (props) {
  return (0, _styledComponents.css)(["color:", ";", " font-weight:", ";text-align:", ";"], props.inverse ? props.theme.color.monochrome1["default"] : props.theme.color.monochrome5["default"], _coreMixins.typography.heading(props.size, false), props.theme.fontWeight[3], props.justify);
});

exports.CountdownContainer = CountdownContainer;

var CountdownTimer = _styledComponents["default"].span.withConfig({
  displayName: "DateCountdownstyle__CountdownTimer",
  componentId: "sc-1un6wh7-1"
})(function (props) {
  var _props$text, _props$text2;

  return (0, _styledComponents.css)(["display:inline-block;", " ", " ", " ", ""], ((_props$text = props.text) === null || _props$text === void 0 ? void 0 : _props$text.prefix) && (0, _styledComponents.css)(["", ""], (0, _coreMixins.spacing)('margin-left', 2)), ((_props$text2 = props.text) === null || _props$text2 === void 0 ? void 0 : _props$text2.suffix) && (0, _styledComponents.css)(["", ""], (0, _coreMixins.spacing)('margin-right', 2)), props.orientation === 'vertical' && (0, _styledComponents.css)(["display:block;margin:0;"]), props.showUnits && props.size === 3 && (0, _styledComponents.css)(["margin-bottom:", ";"], props.theme.typography.paragraph[2].fontDesktop));
});

exports.CountdownTimer = CountdownTimer;

var CountdownSection = _styledComponents["default"].div.withConfig({
  displayName: "DateCountdownstyle__CountdownSection",
  componentId: "sc-1un6wh7-2"
})(function () {
  return (0, _styledComponents.css)(["display:inline-block;", "{display:inline-block;margin:0 1px;}&:last-child{", "{display:none;}}"], _coreSpan.SpanStyles.Span, _coreSpan.SpanStyles.Span);
});

exports.CountdownSection = CountdownSection;
//# sourceMappingURL=DateCountdown.style.js.map